import { DEFAULT_PLATFORM, PLATFORM_OPTIONS } from "./constants";

export function getPlatformLabel(value: string | null): string {
	const platform = PLATFORM_OPTIONS.find((p) => p.value === value);
	return platform ? platform.label : DEFAULT_PLATFORM.label;
}
